module.exports = __webpack_public_path__ + "img/19.29a2cf3c.jpg";